import React from 'react';
import { theme } from '../../config/theme';

const Input = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  touched,
  required = false,
  disabled = false,
  className = '',
  ...props
}) => {
  const showError = touched && error;

  const inputStyles = {
    width: '100%',
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.primary,
    backgroundColor: disabled ? theme.colors.gray[50] : theme.colors.white,
    border: `1px solid ${showError ? theme.colors.error : theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    outline: 'none',
    transition: theme.transitions.base,
  };

  const labelStyles = {
    display: 'block',
    marginBottom: theme.spacing.xs,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.colors.text.primary,
  };

  const errorStyles = {
    marginTop: theme.spacing.xs,
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.error,
  };

  return (
    <div className={className} style={{ marginBottom: theme.spacing.md }}>
      {label && (
        <label htmlFor={name} style={labelStyles}>
          {label}
          {required && <span style={{ color: theme.colors.error }}> *</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        style={inputStyles}
        onFocus={(e) => {
          if (!disabled) {
            e.target.style.borderColor = theme.colors.primary.main;
          }
        }}
        onBlurCapture={(e) => {
          if (!showError && !disabled) {
            e.target.style.borderColor = theme.colors.gray[300];
          }
        }}
        {...props}
      />
      {showError && <div style={errorStyles}>{error}</div>}
    </div>
  );
};

export default Input;